import Vue from "vue";
import { newLogger } from "../../../utils/util";
import network from "../../../utils/network";

let logger = newLogger("TemplateStore");

const urls = {
  templateWithIdentifier: (id, countryId) =>
    `/administration/template-render/merchant/${id}/country/${countryId}`,
};

/**
 * Template render store
 */

const initState = () => {
  return {
    templates: {},
  };
};

const actions = {
  fetchTemplate: async ({ commit }, { id, countryId }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(
        urls.templateWithIdentifier(id, countryId)
      );
      commit("save", { id: id, text: data.text });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  save: (state, { id, text }) => {
    Vue.set(state.templates, id, text);
  },
};

const getters = {
  get: (state) => (id) => {
    return state.templates[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations,
  actions,
  getters,
};
